"use client"

import Image from "next/image"
import { useRouter } from "next/navigation"
import { Button } from "@heroui/button"

import arrow_left_icon from "@/assets/icons/arrow-left.svg"
import { SearchInput } from "@/components/search-input"

export default function Page() {
  const router = useRouter()

  return (
    <div className="flex gap-3">
      <Button
        isIconOnly
        variant="bordered"
        className="border-small !scale-100"
        onPress={() => {
          router.back()
        }}
      >
        <Image src={arrow_left_icon} alt="arrow-left-icon" className="size-6" />
      </Button>
      <SearchInput
        compact
        classNames={{
          base: "hidden sm:block h-auto sm:h-10",
        }}
      />
    </div>
  )
}
